import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Authorization } from "../../../Context/Authorization";
import { Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { AuthContext } from "../../../Context/AuthContext";
import { logActivity } from "../../../utils/LogActivity";
const EditETVisitor = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const Api = process.env.REACT_APP_API;

    const [loading, setLoading] = useState(false);
    const [ecoTourisms, setEcoTourisms] = useState([]);
    const { userId } = useContext(AuthContext);

    const [formData, setFormData] = useState({
        ecoTourismId: "",
        date: "",
        adult: "",
        child: "",
        totalAmount: "",
        edcWorkersEngaged: "",
        roomsOccupied: ""
    });

    /* ---------------- LOAD DATA ---------------- */

    useEffect(() => {
        fetchEcoTourisms();
        fetchVisitor();
    }, []);

    const fetchEcoTourisms = async () => {
        try {
            const config = Authorization();
            const res = await axios.get(`${Api}/api/eco-tourism`, config);
            setEcoTourisms(res.data.data || []);
        } catch {
            toast.error("Failed to load Eco Tourism list");
        }
    };

    const fetchVisitor = async () => {
        try {
            setLoading(true);
            const config = Authorization();
            const res = await axios.get(
                `${Api}/api/eco-tourism-table/${id}`,
                config
            );

            const v = res.data.data;

            setFormData({
                ecoTourismId: v.ecoTourismId?._id,
                date: v.date?.substring(0, 10),
                adult: v.noOfVisitors?.adult,
                child: v.noOfVisitors?.child,
                totalAmount: v.totalAmount,
                edcWorkersEngaged: v.edcWorkersEngaged,
                roomsOccupied: v.roomsOccupied
            });
        } catch {
            toast.error("Failed to load visitor data");
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- HANDLE INPUT ---------------- */

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    /* ---------------- UPDATE ---------------- */

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);
            const config = Authorization();

            const payload = {
                ecoTourismId: formData.ecoTourismId,
                date: formData.date,
                noOfVisitors: {
                    adult: Number(formData.adult),
                    child: Number(formData.child)
                },
                totalAmount: Number(formData.totalAmount),
                edcWorkersEngaged: Number(formData.edcWorkersEngaged),
                roomsOccupied: Number(formData.roomsOccupied)
            };

            await axios.put(
                `${Api}/api/eco-tourism-table/${id}`,
                payload,
                config
            );

            toast.success("Visitor entry updated successfully");
            await logActivity(userId, "Edited ET Visitors", "Edit ET Visitors Form Page", Api);

            navigate("/et-visitors/view");
        } catch (error) {
            toast.error(error.response?.data?.error || "Update failed");
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- UI ---------------- */

    if (loading) {
        return (
            <div className="text-center mt-4">
                <Spinner animation="border" />
            </div>
        );
    }

    return (
        <>
            <div className="page-header">
                <h3 className="page-title"> Edit Eco Tourism </h3>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a href="!#" onClick={(event) => event.preventDefault()}>
                                JFMC
                            </a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Edit Eco Tourism
                        </li>
                    </ol>
                </nav>
            </div>
            <div className="col-md-6 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Edit Eco Tourism Visitors</h4>

                        <Form onSubmit={handleSubmit}>
                            <Form.Group>
                                <label>Eco Tourism</label>
                                <Form.Control
                                    as="select"
                                    id="ecoTourismId"
                                    value={formData.ecoTourismId}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Eco Tourism</option>
                                    {ecoTourisms.map((eco) => (
                                        <option key={eco._id} value={eco._id}>
                                            {eco.ecoTourismName} – {eco.ecoTourismLocation}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>

                            <Form.Group>
                                <label>Date</label>
                                <Form.Control
                                    type="date"
                                    id="date"
                                    value={formData.date}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>

                            <Form.Group>
                                <label>Adult Visitors</label>
                                <Form.Control
                                    type="number"
                                    id="adult"
                                    value={formData.adult}
                                    onChange={handleChange}
                                    min="0"
                                    required
                                />
                            </Form.Group>

                            <Form.Group>
                                <label>Child Visitors</label>
                                <Form.Control
                                    type="number"
                                    id="child"
                                    value={formData.child}
                                    onChange={handleChange}
                                    min="0"
                                    required
                                />
                            </Form.Group>

                            <Form.Group>
                                <label>Total Amount (₹)</label>
                                <Form.Control
                                    type="number"
                                    id="totalAmount"
                                    value={formData.totalAmount}
                                    onChange={handleChange}
                                    min="0"
                                    required
                                />
                            </Form.Group>

                            <Form.Group>
                                <label>EDC Workers Engaged</label>
                                <Form.Control
                                    type="number"
                                    id="edcWorkersEngaged"
                                    value={formData.edcWorkersEngaged}
                                    onChange={handleChange}
                                    min="0"
                                    required
                                />
                            </Form.Group>

                            <Form.Group>
                                <label>Rooms Occupied</label>
                                <Form.Control
                                    type="number"
                                    id="roomsOccupied"
                                    value={formData.roomsOccupied}
                                    onChange={handleChange}
                                    min="0"
                                />
                            </Form.Group>

                            <button type="submit" className="btn btn-gradient-primary mr-2 mt-3">
                                Update
                            </button>

                            <button
                                type="button"
                                className="btn btn-light mt-3"
                                onClick={() => navigate(-1)}
                            >
                                Cancel
                            </button>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditETVisitor;
